import Regions from './containers/Regions';
import reducer from './services/reducer';
import { RegionsState, regionsSelectors } from './services/selectors';
import epics from './services/epics';

export { reducer, RegionsState, regionsSelectors, epics };

export default Regions;



// WEBPACK FOOTER //
// ./src/scenes/Regions/index.ts